import React, { memo, useEffect, useState, useRef } from "react";
import "../css/loader.css";
import logo from "../image/logo.webp";

const Loader = memo(({ fading }) => {
  const [text, setText] = useState("");
  const fullText = "Crafting your resume...";
  const frameRef = useRef(null);
  const indexRef = useRef(0);

  // Optimized typewriter with requestAnimationFrame
  useEffect(() => {
    let startTime = performance.now();
    let lastUpdate = 0;
    const interval = 80; // ms per character

    const updateText = (timestamp) => {
      if (!frameRef.current) return;

      if (timestamp - lastUpdate >= interval) {
        const i = indexRef.current;
        if (i < fullText.length) {
          setText(fullText.slice(0, i + 1));
          indexRef.current = i + 1;
          lastUpdate = timestamp;
          frameRef.current = requestAnimationFrame(updateText);
        } else {
          frameRef.current = null;
        }
      } else {
        frameRef.current = requestAnimationFrame(updateText);
      }
    };

    frameRef.current = requestAnimationFrame(updateText);
    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
      }
    };
  }, []);

  return (
    <div className={`resume-loader ${fading ? "fade-out" : ""}`}>
      {/* Animated background gradient */}
      <div className="loader-bg" />

      {/* Brand Logo – already optimized with srcSet */}
      <img
        src="/src/image/logo-89x80.webp"
        srcSet="/src/image/logo-89x80.webp 89w, /src/image/logo-178x160.webp 178w"
        sizes="(max-width: 768px) 89px, 89px"
        width="89"
        height="80"
        alt="ResumeEra"
        loading="eager"
        decoding="async"
        className="loader-logo"
      />

      {/* Resume Document Icon (CSS) */}
      <div className="resume-icon">
        <div className="resume-lines">
          <span className="line line1" />
          <span className="line line2" />
          <span className="line line3" />
          <span className="line line4" />
        </div>
      </div>

      {/* Typewriter Text */}
      <p className="loader-text">{text}</p>

      {/* Animated progress bar */}
      <div className="progress-track">
        <div className="progress-bar" />
      </div>
    </div>
  );
});

Loader.displayName = "Loader";
export default Loader;